import {
    useEffect,
} from 'react'

import ENV from '@src/constants/Env'

export const CHATWOOT_BASE_URL = 'https://app.chatwoot.com'
export const CHATWOOT_SCRIPT_ID = 'chatwoot-sdk'
export const CHATWOOT_WIDGET_IFRAME_ID = 'chatwoot_live_chat_widget'

const showCloseButton = (): void => {
    const iframe = document.getElementById(CHATWOOT_WIDGET_IFRAME_ID) as HTMLIFrameElement | null

    iframe?.contentWindow?.postMessage(
        `chatwoot-widget:${JSON.stringify({
            event: 'toggle-close-button',
            isMobile: true,
        })}`,
        '*',
    )
}

const useChatwootInit = (): void => {
    useEffect(() => {
        if (document.getElementById(CHATWOOT_SCRIPT_ID)) {
            return undefined
        }

        const websiteToken = ENV.REACT_APP_CHATWOOT_WEBSITE_TOKEN

        if (!websiteToken) {
            return undefined
        }

        window.chatwootSettings = {
            ...window.chatwootSettings,
            hideMessageBubble: true,
        }

        const onReady = (): void => {
            showCloseButton()
        }

        window.addEventListener('chatwoot:ready', onReady)

        const script = document.createElement('script')

        script.id = CHATWOOT_SCRIPT_ID
        script.src = `${CHATWOOT_BASE_URL}/packs/js/sdk.js`
        script.async = true
        script.defer = true
        script.onload = () => {
            window.chatwootSDK?.run({
                websiteToken,
                baseUrl: CHATWOOT_BASE_URL,
            })
        }

        document.body.appendChild(script)

        return () => {
            window.removeEventListener('chatwoot:ready', onReady)
        }
    }, [])
}

export default useChatwootInit
